export default class FormValidators {
  static none = () => {
    return undefined;
  };

  static containsLetters =
    (message = "") =>
    (value: string) => {
      let returnMessage = "This field is cannot contain alphabetical letters.";
      if (message !== "") {
        returnMessage = message;
      }
      const regexp = /^([0-9]|(-)|(\+))/gi;
      const valid = !regexp.test(value);
      return value ? (valid ? undefined : returnMessage) : undefined;
    };

  static required =
    (message = "") =>
    (value: string) => {
      let returnMessage = "This field is required";
      if (message !== "") {
        returnMessage = message;
      }
      return value ? undefined : Number(value) !== 0 && !isNaN(Number(value)) ? undefined : returnMessage;
    };

  static onlySpaces = (value: string) => {
    const returnMessage = "This field cannot contain only spaces";
    if (value && value.replaceAll(/\s/g, "").length === 0) {
      return returnMessage;
    } else {
      return undefined;
    }
  };

  static isURL(value: string) {
    if (!value) {
      return undefined;
    }
    // eslint-disable-next-line
    let regex = /^((http(s)?|ftp)(:\/\/))?([www])?\.?[a-zA-Z0-9-_\.]+(\.[a-zA-Z0-9]{2,})([-a-zA-Z0-9:%_\+.~#?&//=]*)/gi;
    return regex.test(String(value)) ? undefined : "This is not an valid URL address";
  }

  static doesRegexMatch = (regex: RegExp, message: string) => (value: string) => {
    if (!value) {
      return undefined;
    }
    const ret = regex.test(value);
    return ret ? undefined : message;
  };

  static minValue =
    (min: number, message = "") =>
    (value: string) => {
      let returnMessage = `Value must be higher than ${min}`;
      if (message !== "") {
        returnMessage = message;
      }

      if (value === undefined) {
        return undefined;
      } else {
        if (value.toString().startsWith("0")) {
          return parseFloat(value) < min ? returnMessage : undefined;
        }
        return parseFloat(value) < min ? returnMessage : undefined;
      }
    };

  static requiredWhen =
    (flag: boolean, name: string, message = "") =>
    (value: string) => {
      let returnMessage = `Field is required when field "${name}" is not empty`;
      if (message !== "") {
        returnMessage = message;
      }

      if (value) {
        return undefined;
      } else {
        if (flag) {
          return returnMessage;
        } else {
          return undefined;
        }
      }
    };

  static requireField =
    (name: string, required: any, message = "") =>
    (value: string) => {
      let returnMessage = `Field "${name}" is required before entering this one`;
      if (message !== "") {
        returnMessage = message;
      }

      if (value !== undefined) {
        if (!required) {
          return returnMessage;
        } else {
          return undefined;
        }
      } else {
        return undefined;
      }
    };

  static gte =
    (min: number, default_msg: string, message = "") =>
    (value: string) => {
      let returnMessage = `Value must be higher than ${min}`;
      if (message !== "") {
        returnMessage = message;
      }

      if (value === undefined) {
        return undefined;
      } else {
        if (min === -1) {
          return default_msg;
        }
        return parseFloat(value) < min ? returnMessage : undefined;
      }
    };

  static ge =
    (min: number, default_msg: string, message = "") =>
    (value: string) => {
      let returnMessage = `Value must be higher than ${min}`;
      if (message !== "") {
        returnMessage = message;
      }

      if (value === undefined) {
        return undefined;
      } else {
        if (min === -1) {
          return default_msg;
        }
        return parseFloat(value) <= min ? returnMessage : undefined;
      }
    };

  static maxValue =
    (length: number, message = "") =>
    (value: string) => {
      let returnMessage = `Field must be ${length} characters maximum`;
      if (message !== "") {
        returnMessage = message;
      }

      if (value === undefined) {
        return undefined;
      } else {
        return value.length > length ? returnMessage : undefined;
      }
    };

  static positiveValue =
    (message = "") =>
    (value: string) => {
      if (parseInt(value) < 0) {
        return message || "Value should be positive";
      }
      return undefined;
    };

  static inRange =
    (range: { from: number; to: number }, message = "") =>
    (value: string | number) => {
      if (!range) {
        return undefined;
      }
      value = parseFloat(value as any);

      if (value < range.from || value > range.to) {
        return message || `Value should be between ${range.from} and ${range.to}`;
      } else {
        return undefined;
      }
    };

  static secondaryInRange =
    (range: { from: number; to: number }, secondary: string | number, message = "") =>
    (_value: string | number) => {
      if (!range) {
        return undefined;
      }
      secondary = parseFloat(secondary as any);

      if (secondary < range.from || secondary > range.to) {
        return message || `Size in parcels should be between ${range.from} and ${range.to}`;
      } else {
        return undefined;
      }
    };

  static isValidJson(value: string) {
    if (!value) {
      return undefined;
    }
    try {
      JSON.parse(value);
      return undefined;
    } catch {
      return "The object is invalid json";
    }
  }

  static composeValidators =
    (...validators: Array<(value: string) => any>) =>
    (value: string) =>
      validators.reduce((error, validator) => error || validator(value), undefined);
}
